import moment from 'moment';
import { SELECT_DAY, SELECT_TOOL, LOAD_TRACK, TRACK_UPDATES_RECEIVING,
  TRACK_UPDATES_RECEIVED, LOAD_USERGROUPS, SET_SELECTION_MODE } from '../actions/map';
import { SELECT_TOOL_USER, SET_TRACK_HINT, SET_ADMIN_CHECK, SET_ADMIN_CHECK_STEP,
  RECEIVE_ADMIN_CHECK } from '../actions/tools';
import { USER_LOGIN } from '../actions/auth';
import { getValueFromTime } from '../utils';

const initialState = {
  selectedDay: null,
  days: {},
  usergroups: undefined,
  usersMap: {},
  selectedTool: undefined,
  selectedUser: undefined,
  selectedGroup: undefined,
  selectionMode: 'multi',
};

function selectDay(state, action) {
  const selectedDay = getDay(state, action.date);
  state.days[action.date] = selectedDay;
  state.selectedDay = selectedDay;
  return { ...state };
}

function loadTrack(state, action) {
  const track = action.payload;
  const day = getDay(state, new Date(track.day));
  const dayTrack = getDayTrack(day, track.username);
  const updateState = dayTrack.coords.length === 0;
  // dayTrack.coords = dayTrack.coords.concat(track.coords.data);
  dayTrack.medias = dayTrack.medias.concat(track.medias.data);
  processObjects(dayTrack, track.objects);
  dayTrack.infos = dayTrack.infos.concat(track.infos.data);
  dayTrack.reports = dayTrack.reports.concat(track.reports.data);
  dayTrack.stats = { ...track.stats };
  dayTrack.trackGroups = { ...dayTrack.trackGroups };
  dayTrack.trackMedias = { ...dayTrack.trackMedias };
  dayTrack.coordsGroups = { ...dayTrack.coordsGroups };
  day.tracks[dayTrack.trackId] = { ...dayTrack };
  if (state.selectedUser && state.selectedUser.id === dayTrack.trackId) {
    state.selectedTrack = day.tracks[dayTrack.trackId];
  }
  day.tracks = { ...day.tracks };
  return updateState ? { ...state } : state;
}

function loadUsergroups(state, action) {
  state.usergroups = action.payload;
  state.usersMap = {};
  for (const group of state.usergroups) {
    for (const groupuser of group.groupusers) {
      let user = state.usersMap[groupuser.id];
      if (!user) {
        user = groupuser;
        state.usersMap[user.id] = user;
      }
      if (!user.groups) {
        user.groups = [group];
      } else {
        user.groups.push(group);
      }
    }
  }
  return { ...state };
}

function updateReceivingStatus(state, action) {
  const day = getDay(state, action.day);
  day.receivingStatus = action.type;
  return { ...state };
}

function getDay(state, date) {
  const startOfDay = new Date(date);
  startOfDay.setHours(0, 0, 0, 0);
  let day = state.days[startOfDay.getTime()];
  if (!day) {
    day = {
      date: startOfDay,
      locationReceived: 0,
      mediasReceived: 0,
      tracks: {},
    };
    state.days[startOfDay.getTime()] = day;
  }
  return day;
}

function getDayTrack(day, trackId) {
  let track = day.tracks[trackId];
  if (!track) {
    track = {
      trackId,
      coords: [],
      groups: {},
      medias: [],
      trackGroups: {},
      mediaGroups: {},
      coordsGroups: {},
      objects: {},
      infos: [],
      reports: [],
      stats: {},
      adminCheck: 0,
      adminCheckStep: 10,
      adminCheckChanged: 0,
    };
    day.tracks[trackId] = track;
  }
  return track;
}

function processObjects(track, nextObjects) {
  for (const objectId of Object.keys(nextObjects)) {
    const nextObject = nextObjects[objectId];
    let object = track.objects[objectId];
    if (object && object.revision === nextObject.revision) {
      object.data = object.data.concat(nextObject.data);
      object.props = nextObject.props;
    } else {
      object = nextObject;
      track.objects[objectId] = nextObject;
    }
    if (object.type === 'group') {
      track.trackGroups[objectId] = object;
    } else if (object.type === 'coords') {
      track.coordsGroups[objectId] = object;
    } else if (object.type === 'media') {
      track.mediaGroups[objectId] = object;
      const media = track.medias.find(item => item.filename === object.props.filename);
      if (media) {
        media.trackObject = object;
      }
    }
  }
}

function selectToolUser(state, action) {
  state.selectedUser = action.user;
  state.selectedGroup = action.group;
  if (state.selectedUser) {
    state.selectedTrack = state.selectedDay.tracks[state.selectedUser.id];
  }
  if (action.center && state.selectedTrack) {
    let firstMediaCoord;
    const firstMedia = state.selectedTrack.medias.find(media => media.trackObject);
    if (firstMedia) {
      firstMediaCoord = firstMedia.trackObject.data[0];
    }
    if (firstMediaCoord) {
      state.mapCenter = [...firstMediaCoord];
    } else if (state.selectedTrack.stats.lastLocation) {
      state.mapCenter = [...state.selectedTrack.stats.lastLocation];
    }
  }
  return { ...state };
}

function setTrackHint(state, action) {
  const { absoluteTime, track } = action;
  const user = state.usersMap[track.trackId];
  let hint;
  if (absoluteTime) {
    const info = getValueFromTime(absoluteTime, track.infos);
    if (info) {
      const [time, battery, memory] = info;
      hint = `
        <b>${user.name}</b><br/>
        Время: ${moment(time).format('HH:mm')}<br/>
        Батарея: ${battery}%<br/>
        Память: ${memory}
      `;
    }
  } else {
    hint = `<b>${user.name}</b>`;
  }
  action.track.hint = hint;
  return { ...state };
}

function receiveAdminCheck(state, action) {
  const { trackId, checkdate, changed, count } = action.payload;
  const day = state.days[new Date(checkdate)];
  if (day) {
    const track = day.tracks[trackId];
    if (track && track.adminCheckChanged < changed) {
      track.adminCheck = count;
      track.adminCheckChanged = changed;
      return { ...state };
    }
  }
  return state;
}

export default function reduceMap(state = initialState, action) {
  switch (action.type) {
    case SELECT_DAY:
      return selectDay(state, action);
    case LOAD_TRACK:
      return loadTrack(state, action);
    case TRACK_UPDATES_RECEIVING:
    case TRACK_UPDATES_RECEIVED:
      return updateReceivingStatus(state, action);
    case LOAD_USERGROUPS:
      return loadUsergroups(state, action);
    case SELECT_TOOL:
      state.selectedTool = action.tool;
      return { ...state };
    case SELECT_TOOL_USER:
      return selectToolUser(state, action);
    case SET_SELECTION_MODE:
      state.selectionMode = action.mode;
      return { ...state };
    case SET_TRACK_HINT:
      return setTrackHint(state, action);
    case SET_ADMIN_CHECK:
      if (state.selectedTrack) {
        state.selectedTrack.adminCheck = Math.max(action.value, 0);
        state.selectedTrack.adminCheckChanged = action.changed;
      }
      return { ...state };
    case SET_ADMIN_CHECK_STEP:
      if (state.selectedTrack) {
        state.selectedTrack.adminCheckStep = action.value;
      }
      return { ...state };
    case RECEIVE_ADMIN_CHECK:
      return receiveAdminCheck(state, action);
    case USER_LOGIN:
      if (action.login.indexOf('moscow') !== -1 || action.login === 'Client0306' || action.login === 'clientmsk') {
        return { ...state, mapCenter:[55.755814, 37.617635] };
      }
      return state;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/map.js